
import { defineComponent } from 'vue'
import Button from '@/components/elements/Button.vue'

export default defineComponent({
  name: 'CbtFail',
  components: {
    Button
  },
  setup() {
    localStorage.setItem('myAnswers', '')
  }
})
